<div class="container mt-3">
  <div class="row">
    <!-- Lista de conversaciones (ancho 4) -->
    <div class="col-12 col-md-4">
      <h4 class="text-center mb-3">Conversaciones</h4>
      <div class="row g-3">
        <div class="col-12" *ngFor="let conversacion of conversaciones">
          <mat-card class="conversation-card" (click)="seleccionarConversacion(conversacion)">
            <!-- Encabezado -->
            <div class="d-flex justify-content-between align-items-center">
              <div class="fw-bold nombreContacto" >{{ conversacion.nombreContacto }}</div>
              <span class="badge bg-danger" *ngIf="conversacion.mensajesSinLeer > 0">
                {{ conversacion.mensajesSinLeer }}
              </span>
            </div>

            <!-- Cuerpo -->
            <div class="mt-2 text-muted small">
              {{ conversacion.fechaUltimoMensaje | date:'short' }} Hrs
            </div>
            <div class="mt-2 text-truncate ultimoMensaje">
              {{ conversacion.ultimoMensaje }}
            </div>
          </mat-card>
        </div>
      </div>
    </div>

    <!-- Detalle de conversación (ancho 8) -->
    <div class="col-12 col-md-8">
      <h4 class="text-center mb-3">Detalle de la Conversación</h4>
      <div *ngIf="conversacionSeleccionada; else noSeleccion">
        <app-conversation-detail
          [conversacion]="conversacionSeleccionada">
        </app-conversation-detail>
      </div>
      <ng-template #noSeleccion>
        <div class="text-center text-muted" style="margin: 150px auto;">
          <p>Selecciona una conversación para ver los detalles.</p>
        </div>
      </ng-template>
    </div>
  </div>
</div>
